import styled from 'styled-components';

export const AggregatedReportStyled = styled.div`
  display: flex;
  justify-content: end;
  margin: 8px 0 16px 0;
`;
